import React from 'react';

import { PassoExecutado } from '@/models/PassoExecutado';
import SolicitacaoListPrescricaoMedica from '../SolicitacaoList/SolicitacaoListPrescricaoMedica';
import SolicitacaoListExame from '../SolicitacaoList/SolicitacaoListExame';
import SolicitacaoListProcedimento from '../SolicitacaoList/SolicitacaoListProcedimento';
import SolicitacaoListAgendamento from '../SolicitacaoList/SolicitacaoListAgendamento';
import SolicitacaoListEncaminhamento from '../SolicitacaoList/SolicitacaoListEncaminhamento';
import SolicitacaoListOrientacoesMedicas from '../SolicitacaoList/SolicitacaoListOrientacoesMedicas';

import { Container } from './styles';

interface Props {
  passo: PassoExecutado;
}

const SolicitacaoListSection: React.FC<Props> = ({ passo }) => {
  return (
    <Container>
      <SolicitacaoListPrescricaoMedica passo={passo} />
      <SolicitacaoListExame passo={passo} />
      <SolicitacaoListProcedimento passo={passo} />
      <SolicitacaoListEncaminhamento passo={passo} />
      <SolicitacaoListAgendamento passo={passo} />
      <SolicitacaoListOrientacoesMedicas passo={passo} />
    </Container>
  );
};

export default SolicitacaoListSection;
